/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Auth from "../shared/Auth";
import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import ScrollHandler from "./ScrollHandler";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class OrderProducts extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: null,
            page: 0
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load() {
        if (this.state.eol)
            return;
        if (this.props.orderID) {
            qreq.get('/api/product/list/order?orderID=' + this.props.orderID, j => {
                if (j.list)
                    this.setState({ list: j.list, eol: true });
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
        else {
            this.setState({ loading: true });
            qreq.get('/api/product/list/order?page=' + (this.state.page + 1), j => {
                if (j.list) {
                    if (!this.state.list)
                        this.setState({ list: j.list, page: this.state.page + 1 });
                    else if (this.state.list && j.list.length > 0) {
                        var list = [...this.state.list, ...j.list];
                        this.setState({ list: list, page: this.state.page + 1 });
                    }
                    else if (j.list.length === 0)
                        this.setState({ eol: true });
                }
                else
                    this.alert(j.errorMessage);
                this.setState({ loading: false });
            }, () => {
                this.unkownErrorCallback();
                this.setState({ loading: false });
            });
        }
    }

    render() {
        if (!this.state.list)
            return null;
        const columns = [
            { name: 'productName', title: 'Product', className: 'd-none d-md-table-cell' },
            { name: 'size', title: 'Size' },
            { name: 'quantity', title: 'Quantity', className: 'd-none d-md-table-cell' },
            { name: 'lotNumber', title: 'Lot #', className: 'd-none d-md-table-cell' },
            {
                name: 'appliedDate', title: 'Applied', valueFunc: row => {
                    return Globals.toMDYLocalDateString(row.appliedDate);
                },
                onClick: row => this.props.navigate('/visit/view/' + row.visitID)
            },
            {
                name: 'isBilled', title: 'Billed', valueFunc: row => {
                    if (row.isBilled)
                        return 'x' + row.billedQuantity + (Auth.hasRole('admin') ? ' (' + Globals.formatter.format(row.billedAmount) + ')' : '');
                    return 'No';
                }, className: 'd-none d-md-table-cell'
            }
        ];
        if (!this.props.orderID) {
            columns.splice(0, 0, { name: 'patientNameDOB', title: 'Patient', onClick: row => this.props.navigate('/order/view/' + row.orderID) });
            columns.splice(0, 0, { name: 'oid', title: 'Order', onClick: row => this.props.navigate('/order/view/' + row.orderID), className: 'd-none d-md-table-cell' });
        }
        return <>
            <DataTable data={this.state.list} columns={columns} />
            <ScrollHandler onScroll={this.load} />
            {this.state.loading ? <LoadingAlert /> : null}
        </>
    }
}

export default withParamsAndNavigate(OrderProducts);